export default __webpack_public_path__ + "static/media/zelle.e663d2bc.png";